import lazyLoading from './lazyLoading'
export default(routers,data) => {
	data = typeof data === 'string' ? JSON.parse(data) : data
	generaMenu(routers,data)
}

function generaMenu(routers,data){
	data.forEach((item) => {
		let menu = Object.assign({},item)
		menu.component = lazyLoading(menu.remark ? menu.remark.toLowerCase() : '')
		if(item.children) {
			menu.children = []
			let dataItem = item.children
			generaMenu(menu.children,dataItem)
        }
		routers.push(menu)
	})
}



// WEBPACK FOOTER //
// ./src/utils/menuUtils.js